import { TCoreWidgetSettingsLoaded, WidgetType } from 'types/GlobalWidget'
import { KpiOptionObject } from 'types/GlobalKpiOption'
import { IMetric } from 'types/GlobalMetric'

export const getShowUnitWarning = (
  metric: IMetric,
  widget?: TCoreWidgetSettingsLoaded | null
) => {
  if (!widget) {
    return false
  }

  const mainKpi = widget.settings.kpi_options.find(
    (kpi) => kpi.index === 0
  ) as KpiOptionObject

  const recommendSameUnit = [
    WidgetType.BAR_CHART,
    WidgetType.LINE_CHART
  ].includes(widget.settings.type.selected)

  return recommendSameUnit && mainKpi.unit !== metric.unit
}
